import React, { CSSProperties, useMemo } from "react";
import { cn } from "@edusogno/lib/utils";

type CourseItemProps = {
  course_name: string;
  months: number;
  course_structure: {
    speaking: number;
    grammar: number;
    ielts: number;
    linguaskill: number;
    one_to_one: number;
    writing_correction: number;
  }[];
  course_structure_week: {
    speaking: number;
    grammar: number;
    ielts: number;
    linguaskill: number;
    one_to_one: number;
    writing_correction: number;
  }[];
  link_onboarding: string;
};

type Props = {
  course: never;
  isOneToOne?: boolean;
};

type ItemProps = {
  textColor?: string;
  backgroundColor?: string;
  width?: string | number;
  height?: string | number;
  y?: string | number;
  type?: string;
  duration?: string | number;
  style?: CSSProperties;
  renderText?: () => React.ReactNode;
};

// type MonthProps = {
//   text?: string;
//   width?: string;
//   height?: string;
//   style?: React.CSSProperties;
// };

type CourseSchedule = {
  [x: string]: {
    start: number | null;
    monthDuration: number;
    weeklyDuration?: number;
    classes: number;
    height?: number;
  };
};

// const CourseMonth: React.FC<MonthProps> = ({ text = "Month", ...props }) => (
//   <svg fill="none" xmlns="http://www.w3.org/2000/svg" {...props}>
//     {/* <g> */}
//     <rect x={0} y={0} width="100%" height="100%" rx="4%" fill="white" />
//     <svg width={"100%"} height={"100%"}>
//       <switch>
//         <foreignObject x="0" y="0" width="100%" height="100%">
//           <p className="text-center text-secondary flex items-center justify-center text-[8px] font-semibold h-full">
//             {text}
//           </p>
//         </foreignObject>
//       </switch>
//     </svg>
//     {/* </g> */}
//   </svg>
// );

const CourseItem: React.FC<ItemProps> = ({
  textColor = "#2D224C",
  backgroundColor = "#D9DAF3",
  duration = "2",
  renderText,
  type = "Speaking",
  ...props
}) => (
  <svg
    // viewBox="0 0 64 23"
    fill="none"
    xmlns="http://www.w3.org/2000/svg"
    {...props}
    className="max-h-[39px]"
  >
    {/* <rect
      y={"0%"}
      width={"100%"}
      height={"100%"}
      rx={8}
      fill={backgroundColor}
    /> */}

    {/* <g>
      <rect
        className=" min-w-[100px]"
        x={"2%"}
        y={"25%"}
        width={"64px"}
        height={"50%"}
        rx={4.5}
        fill={backgroundColor}
        stroke={textColor}
      />
      <text
        fill={textColor}
        fontSize={"11px"}
        // fontSizeAdjust={"0.58"}
        x={"13%"}
        y={"58%"}
        width={"12%"}
        height={"50%"}
        fontWeight={600}
        textAnchor="middle"
        alignmentBaseline="central"
        // style={{ textAlign: "center" }}
      >
        {type}
      </text>
    </g> */}
    {/* <foreignObject x="13%" y="25%" width="64px" height="50%">

    </foreignObject> */}
    <svg width={"100%"} height={"100%"}>
      <switch>
        <foreignObject x="0" y="0" width="100%" height="100%">
          <div
            className="w-full rounded-[8px] flex flex-row items-center justify-between px-2 h-full"
            style={{
              backgroundColor: backgroundColor,
            }}
          >
            <p
              className="text-center w-[64px] flex items-center my-auto justify-center text-[11px] border-[1.5px] font-semibold rounded-[4.5px] h-[90%] max-h-[22px]"
              style={{ borderColor: textColor, color: textColor }}
            >
              {type}
            </p>

            <p
              className={cn(
                "text-center flex flex-col items-end pr-[2%] font-semibold justify-center text-[11px] h-full",
              )}
              style={{ color: textColor }}
            >
              {renderText ? renderText() : <>{duration}h/w</>}
            </p>
          </div>
        </foreignObject>
      </switch>
    </svg>
    
    {/* <text
      fill={textColor}
      fontSize={"100%"}
      fontWeight={"600"}
      x={"86%"}
      y={"58%"}
      width={"12%"}
      height={"50%"}
    ></text> */}
  </svg>
);
const MobileCourseStructureTemplate: React.FC<Props> = (props) => {
  const course = props?.course as CourseItemProps;
  // const courseItem = course.course_structure_week[0];
  const monthWidth = 100 / course.months;

  const CourseStructure = useMemo(() => {
    const structure: CourseSchedule = {
      speaking: {
        start: null,
        monthDuration: 0,
        weeklyDuration: 0,
        classes: 0,
      },
      grammar: {
        start: null,
        monthDuration: 0,
        weeklyDuration: 0,
        classes: 0,
      },
      ielts: { start: null, monthDuration: 0, weeklyDuration: 0, classes: 0 },
      linguaskill: {
        start: null,
        monthDuration: 0,
        weeklyDuration: 0,
        classes: 0,
      },
      one_to_one: {
        start: null,
        monthDuration: 0,
        weeklyDuration: 0,
        classes: 0,
      },
      writing_correction: {
        start: null,
        monthDuration: 0,
        weeklyDuration: 0,
        classes: 0,
      },
    };

    const courseStructure = course?.course_structure_week ?? [];
    const keys = Object.keys(courseStructure?.[0] ?? {}) as Array<
      keyof (typeof courseStructure)[0]
    >;

    for (let i = 0; i < courseStructure.length; i++) {
      for (let j = 0; j < keys.length; j++) {
        const k = keys[j];

        const l = courseStructure[i][k];

        if (l > 0) {
          if (structure[k]?.start === null) {
            structure[k].start = i;
            // structure[k].height = ;
            structure[k].weeklyDuration = l;
            structure[k].classes = l;
          }
          structure[k].monthDuration = structure[k].monthDuration + 1;
        }
      }
    }

    // one to one is the outlier
    if (Object.keys(structure).includes("one_to_one")) {
      const courseWeekStructure = course?.course_structure_week ?? [];
      for (let i = 0; i < courseWeekStructure.length; i++) {
        //  for (let j = 0; j < keys.length; j++) {
        const k = "one_to_one";

        const l = courseWeekStructure[i][k];

        if (l > 0) {
          if (structure[k]?.start === null) {
            structure[k].start = i;
            structure[k].classes = l;
          }
          structure[k].monthDuration = structure[k].monthDuration + 1;
        }
        //  }
      }
    }
    return structure;
  }, [course.course_structure_week]);

  // const Months = useMemo(
  //   () =>
  //     Array.from({ length: course.months }).map((_, idx) => (
  //       <CourseMonth
  //         width={"100%"}
  //         key={"course+" + idx}
  //         height="100%"
  //         text={`Month ${idx + 1}`}
  //         // style={{ transform: `translate(${idx * 18}%, 0%)` }}
  //       />
  //     )),
  //   [course.months],
  // );

  return (
    <svg
      width="100%"
      xmlns="http://www.w3.org/2000/svg"
      height="100%"
      className="min-h-[103px] flex h-full flex-1"
    >
      <defs>
        <linearGradient id="gradient" x1="0%" y1="0%" x2="100%" y2="100%">
          <stop offset="0%" stopColor="#6a0068" />
          <stop offset="30%" stopColor="#300035" />
          <stop offset="100%" stopColor="#005d88" />
        </linearGradient>
      </defs>
      <style />
      <rect
        x="0%"
        y="0%"
        rx={7}
        ry={7}
        fill="url(#gradient)"
        width="100%"
        height="100%"
      />

      <switch>
        <foreignObject x="0" y="0" width="100%" height="100%">
          <div
            style={{ height: "100%" }}
            className="flex flex-col flex-[1_1_100%] pt-2  md:py-4 w-full h-full gap-4 items-center justify-start md:justify-start"
          >
            {/* <p className="text-center flex flex-col text-white flex items-center justify-center font-semibold text-sm 2xl:text-base">
              {course?.course_name}
            </p> */}

            {/* <div
              className="flex flex-row gap-[2px] items-center h-[13px] w-full px-[4px]"
              // style={{ gridTemplateColumns: `repeat(auto,${course.months})` }}
            >
              {Months}
            </div> */}

            <div className="flex  flex-[1_1_auto] px-[4px] flex-col w-full h-[calc(100%_-_32px)] gap-2">
              {CourseStructure?.speaking.monthDuration > 0 && (
                <CourseItem
                  type="Speaking"
                  duration={CourseStructure?.speaking.weeklyDuration}
                  width={`${
                    monthWidth * CourseStructure?.speaking.monthDuration
                  }%`}
                  height={"auto"}
                  style={{
                    marginLeft: `${
                      (CourseStructure?.speaking.start ?? 0) * monthWidth
                    }%`,
                  }}
                />
              )}

              {CourseStructure?.grammar.monthDuration > 0 && (
                <CourseItem
                  backgroundColor="#E7DEFF"
                  textColor="#8065C9"
                  type="Grammar"
                  duration={CourseStructure?.grammar?.weeklyDuration}
                  // y={"14%"}
                  width={`${
                    monthWidth * CourseStructure?.grammar.monthDuration
                  }%`}
                  height={"auto"}
                  style={{
                    marginLeft: `${
                      (CourseStructure?.grammar.start ?? 0) * monthWidth
                    }%`,
                  }}
                />
              )}

              {CourseStructure?.ielts.monthDuration > 0 && (
                <CourseItem
                  backgroundColor="#74DFAC"
                  textColor="#2D224C"
                  // y={"28%"}
                  width={`${
                    monthWidth * CourseStructure?.ielts.monthDuration
                  }%`}
                  height={"auto"}
                  style={{
                    marginLeft: `${
                      (CourseStructure?.ielts.start ?? 0) * monthWidth
                    }%`,
                  }}
                  type="IELTS"
                  duration={CourseStructure?.ielts.weeklyDuration}
                />
              )}

              {CourseStructure?.writing_correction?.monthDuration > 0 && (
                <CourseItem
                  backgroundColor="#8065C9"
                  textColor="#FFFFFF"
                  // y={"42%"}
                  width={`${
                    monthWidth *
                    CourseStructure?.writing_correction.monthDuration
                  }%`}
                  height={"auto"}
                  style={{
                    marginLeft: `${
                      (CourseStructure?.writing_correction.start ?? 0) *
                      monthWidth
                    }%`,
                  }}
                  type="Writing"
                  duration={CourseStructure?.writing_correction?.weeklyDuration}
                />
              )}

              {CourseStructure?.one_to_one.classes &&
              CourseStructure?.one_to_one.classes > 0 ? (
                <CourseItem
                  backgroundColor="#8065C9"
                  textColor="#FFFFFF"
                  // y={"28%"}
                  width={"100%"}
                  // width={`${
                  //   monthWidth * CourseStructure?.one_to_one.monthDuration
                  // }%`}
                  height={"auto"}
                  style={{
                    marginLeft: `${
                      (CourseStructure?.one_to_one.start ?? 0) * monthWidth
                    }%`,
                  }}
                  type="1:1 classes"
                  // duration={CourseStructure?.one_to_one.weeklyDuration}
                  renderText={() =>
                    `${
                      CourseStructure?.one_to_one.classes
                      //  *
                      // course?.course_structure.length
                    } classes`
                  }
                />
              ) : (
                <></>
              )}
            </div>
          </div>
        </foreignObject>
      </switch>
    </svg>
  );
};
export default MobileCourseStructureTemplate;
